import React from 'react';
import PropTypes from 'prop-types';

import { format } from 'inside-out/managers/dateManager';
import { Link } from 'inside-out/components/shared/link';

import {
	wrapperStyle,
	wrapperLinkStyle,
	metaDateStyle,
	metaLocationStyle,
	titleStyle,
	bodyStyle,
} from './styles';

export class CarouselCard extends React.PureComponent {
  static propTypes = {
    background: PropTypes.string,
    body: PropTypes.string,
    date: PropTypes.string,
    endDate: PropTypes.string,
    location: PropTypes.string,
    title: PropTypes.string,
    to: PropTypes.string,
  }

	render() {
    const {
      background,
			body,
			date,
			endDate,
			location,
			title,
			to,
		} = this.props;

		let formattedDate = format(date, endDate);

		return (
			<Link className={wrapperLinkStyle} to={to} data-component="Card">
				<article className={wrapperStyle(background)}>
					<h1 className={titleStyle}>{title}</h1>
					<p className={bodyStyle}>{body}</p>
					{ location && (
						<p className={metaLocationStyle}>{location}</p>
					)}
					{ formattedDate && (
						<p className={metaDateStyle}>{formattedDate}</p>
					)}
				</article>
			</Link>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/shared/cards/carouselCard/component.js